import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";
import { isSelfHostedDistribution } from "utils/distribution";
import useTypedFlags from "hooks/useTypedFlags";
import { AccountContext } from "views/AccountWrapper";

import styles from "./styles.module.css";
import DashboardOverviewColumnOnboardingSaaS from "./OnboardingSaaS";
import DashboardOverviewColumnTestPilot from "./TestPilot";
import DashboardOverviewColumnLeaveFeedback from "./LeaveFeedback";
import DashboardOverviewColumnUserActivity from "./UserActivity";
import { DashboardContext } from "../context";
import { OverviewStaticWidget } from "../types";
import DashboardOverviewColumnOnboardingSelfHosted from "./OnboardingSelfHosted";
import DashboardOverviewColumnAnnouncement from "./Announcement";
import { getBannerProps, shouldRenderBanner } from "./Announcement/helpers";
import { IAC_CONF_ANNOUNCEMENT_ID } from "./IacConfAnnouncement/constants";
import DashboardOverviewColumnIacConfAnnouncement from "./IacConfAnnouncement";

const isSelfHosted = isSelfHostedDistribution();

const DashboardOverviewColumn = () => {
  const { feMarketingBanners } = useTypedFlags();
  const { viewer } = useTypedContext(AccountContext);
  const { config } = useTypedContext(DashboardContext);
  const tab = config["overview"];
  const widgets = tab.overviewColumn
    ? tab.overviewColumn.reduce(
        (acc, next) => (!next.hidden ? [...acc, next.value] : acc),
        [] as OverviewStaticWidget[]
      )
    : [];

  return (
    <Box
      className={styles.overviewColumn}
      gap="x-large"
      direction="column"
      padding="x-large x-large x-large 0"
    >
      {feMarketingBanners.map((banner) => {
        if (!shouldRenderBanner(banner.expirationDate)) return null;

        if (banner.id === IAC_CONF_ANNOUNCEMENT_ID) {
          return <DashboardOverviewColumnIacConfAnnouncement key={banner.id} />;
        }

        const bannerProps = getBannerProps(banner.id);
        if (!bannerProps) return null;

        return <DashboardOverviewColumnAnnouncement key={banner.id} {...bannerProps} />;
      })}
      {widgets.includes(OverviewStaticWidget.LaunchPad) &&
        viewer.admin &&
        (isSelfHosted ? (
          <DashboardOverviewColumnOnboardingSelfHosted />
        ) : (
          <DashboardOverviewColumnOnboardingSaaS />
        ))}
      {widgets.includes(OverviewStaticWidget.UserActivity) && viewer.admin && (
        <DashboardOverviewColumnUserActivity />
      )}
      <DashboardOverviewColumnTestPilot />
      <DashboardOverviewColumnLeaveFeedback />
    </Box>
  );
};

export default DashboardOverviewColumn;
